import { merchantsService } from "services";

import { agentSetupConstants } from "./agentSetup.constants";

export const agentSetupActions = {
	getAgentCompanies,
	getAgent,

	getWhoCantTheySee,
	getWhoCanSeeThem,
};

function getAgentCompanies() {
	return dispatch => {
		return merchantsService.getAgentCompanies().then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};

	function success(agentCompaniesList) {
		return {
			type: agentSetupConstants.GET_AGENT_COMPANIES_SUCCESS,
			agentCompaniesList,
		};
	}
	function failure(error) {
		return { type: agentSetupConstants.GET_AGENT_COMPANIES_ERROR, error };
	}
}

function getAgent(agentId) {
	return dispatch => {
		dispatch(request());

		return merchantsService.getAgent(agentId).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};

	function request() {
		return {
			type: agentSetupConstants.GET_AGENT_FORM_DATA_REQUEST,
		};
	}

	function success(agentFormData) {
		return {
			type: agentSetupConstants.GET_AGENT_FORM_DATA_SUCCESS,
			agentFormData,
		};
	}

	function failure(error) {
		return {
			type: agentSetupConstants.GET_AGENT_FORM_DATA_ERROR,
			error,
		};
	}
}

// Actions for Who can they see? Tab in Edit Agent Setup

function getWhoCantTheySee(id) {
	return dispatch => {
		return merchantsService.getWhoCantTheySee(id).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};

	function success(whoCanTheySee) {
		return {
			type: agentSetupConstants.GET_WHO_CAN_THEY_SEE_SUCCESS,
			whoCanTheySee,
		};
	}
	function failure(error) {
		return { type: agentSetupConstants.GET_WHO_CAN_THEY_SEE_ERROR, error };
	}
}

// Actions for Who can See Them? Tab in Edit Agent Setup

function getWhoCanSeeThem(id) {
	return dispatch => {
		return merchantsService.getWhoCanSeeThem(id).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};

	function success(whoCanSeeThem) {
		return {
			type: agentSetupConstants.GET_WHO_CAN_SEE_THEM_SUCCESS,
			whoCanSeeThem,
		};
	}
	function failure(error) {
		return { type: agentSetupConstants.GET_WHO_CAN_SEE_THEM_ERROR, error };
	}
}
